<style scoped lang="less">
.tables {
	padding: 0 0.8rem 1.2rem 0.8rem;
	background: #fff;
	box-sizing: border-box;

	.paginations {
		height: 3rem;
		line-height: 3rem;

		input {
			width: 3rem;
			height: 1.8rem;
			padding: 0 0 0 0.8rem;
			border: 1px solid #ccc;
		}
	}

	.tabsnum {
		height: 4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		p {
			color: #333;
		}

		.elpagian {
			margin-right: 1rem;
		}
	}
}

.manageselect {
	display: flex;
	// border: 1px solid;
	padding: 20px;
	background-color: #fff;
	box-sizing: 0 5px 5px 5px rgba(255, 255, 255, 0.6);
	border-radius: 10px;
	margin-bottom: 20px;

	.sclectlable {
		margin-right: 20px;
	}
}

.resourbtn {
	padding: 15px 10px;
	// border: 1px solid;
	background-color: #f7f7f7;

	/deep/ .el-button {
		i {
			margin-right: 5px;
			font-size: 16px;
		}

		span {
			margin-right: 0 !important;
		}
	}

	button {
		background-color: #0a68e3;
		border: none;
	}
	// button:last-child {
	// 	background-color: #ff8300;
	// }

	button:nth-of-type(2) {
		background-color: #ff4168;
	}
}

.tabslis {
	button {
		color: #fff;
	}

	/deep/ th {
		text-align: center;
		color: #333;
		font-weight: 600 !important;
	}

	/deep/ td {
		text-align: center;
	}
	/deep/ td:nth-of-type(1) {
		text-align: left;
	}
	.scostatus {
		margin: auto;
		border-radius: 10px;
		color: #fff;
		width: 80px;
		height: 30px;
		line-height: 30px;
		font-size: 14px;
		background-color: #f41127;
	}
}

.qutionitem {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin: 20px 0;
	.qutionits {
		margin-right: 20px;
	}
}
</style>
<template>
	<div>
		<titles titlename="题库管理" titlecontent="这里可以看到题库管理一些信息" :mbx="paths"></titles>

		<div class="manageselect">
			<div class="sclectlable">
				<div>
					<el-select v-model="pagesobj.SKY_GUID" clearable clearable placeholder="请选择知识专业">
						<el-option v-for="item in knowledge" :key="item.SKY_GUID" :label="item.SKY_KonwledgeName" :value="item.SKY_GUID"></el-option>
					</el-select>
				</div>
			</div>
			<div class="sclectlable">
				<div>
					<el-select v-model="pagesobj.SQT_GUID" clearable placeholder="请选择试题类型">
						<el-option v-for="item in testtypelist" :key="item.SQT_GUID" :label="item.SQT_Name" :value="item.SQT_GUID"></el-option>
					</el-select>
				</div>
			</div>
			<div class="sclectlable">
				<div>
					<el-select v-model="pagesobj.PCT_IsState" clearable placeholder="是否公开">
						<el-option label="公开" value="1"></el-option>
						<el-option label="私密" value="0"></el-option>
					</el-select>
				</div>
			</div>
			<div class="sclectlable">
				<div>
					<el-select v-model="pagesobj.pro_guid" clearable placeholder="请选择专业" @change="getpolist()">
						<el-option v-for="item in prolist" :key="item.pro_guid" :label="item.pro_name" :value="item.pro_guid"></el-option>
					</el-select>
				</div>
			</div>
			<div class="sclectlable">
				<div>
					<el-select v-model="pagesobj.PR_GUID" clearable placeholder="请选择岗位">
						<el-option v-for="item in polist" :key="item.PR_GUID" :label="item.PR_ProfessionalName" :value="item.PR_GUID"></el-option>
					</el-select>
				</div>
			</div>
			<div class="sclectlable">
				<div>
					<el-select v-model="pagesobj.IL_GUID" clearable placeholder="请选择考核等级">
						<el-option v-for="item in gradeget" :key="item.IL_GUID" :label="item.IL_LevelTitle" :value="item.IL_GUID"></el-option>
					</el-select>
				</div>
			</div>
			<div class="sclectlable">
				<div>
					<el-date-picker
						v-model="quesvalue"
						type="datetimerange"
						value-format="yyyy-MM-dd hh:mm:ss"
						align="right"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						:default-time="['12:00:00', '08:00:00']"
					></el-date-picker>
				</div>
			</div>

			<div class="primarybtn" @click="getresours()"><el-button type="primary" icon="el-icon-search">搜索</el-button></div>
		</div>
		<div class="resourbtn">
			<el-button @click="addtimu()" type="primary" size="small" icon="fa fa-plus">添加题型</el-button>
			<el-button @click="addtimulist()" type="primary" size="small" icon="fa fa-plus">批量导入</el-button>

			<el-button @click="gosettimulist()" type="primary" size="small" style="background-color: #fbc02d;" icon="fa fa-plus">批量导出</el-button>
		</div>
		<div class="tables">
			<div class="tabslist">
				<div class="paginations">
					每页显示
					<input @change="changetablesize()" type="number" oninput="if(value>30)value=30;if(value<2)value=1" v-model="pagesobj.pageSize" />
					行
				</div>
				<div class="tabslis">
					<template>
						<el-table
							:data="tableData"
							ref="childtable"
							id="childtable"
							@select="selectionchange"
							@select-all="handleSelectAll"
							header-row-class-name="tablestitle"
							border
							style="width: 100%"
						>
							<!-- <el-table-column type="selection" width="55"></el-table-column> -->
							<el-table-column label="题目内容" :resizable="false" prop="SQB_Question"></el-table-column>
							<el-table-column label="试题类型" :resizable="false" prop="SQT_Name" width="100"></el-table-column>
							<el-table-column label="知识专业" :resizable="false" prop="SKY_KonwledgeName" width="100"></el-table-column>
							<el-table-column label="所属岗位" :resizable="false" prop="PR_ProfessionalName" width="100"></el-table-column>
							<el-table-column label="考核等级" :resizable="false" prop="IL_LevelTitle" width="100"></el-table-column>
							<el-table-column label="显示状态" :resizable="false" width="120">
								<template slot-scope="scope">
									<div
										:style="{ background: scope.row.SQB_IsDispark ? '#38b48b' : '#ff0000' }"
										style="line-height: 30px;border-radius: 50px;width: 100px;height: 30px;color: #fff;margin: 0 auto;"
									>
										{{ scope.row.SQB_IsDispark ? '公开' : '禁用' }}
									</div>
								</template>
							</el-table-column>
							<el-table-column label="创建时间" :resizable="false" prop="CreateTime" width="200"></el-table-column>
							<el-table-column label="操作" :resizable="false" fixed="right" width="200px">
								<template slot-scope="scope">
									<el-button v-if="scope.row.isenit" plain size="mini" @click="editszy(scope.row)" style="background-color: #57b5da;margin: 0 10px;">
										编辑
									</el-button>
									<el-popconfirm title="是否删除该条记录？" @confirm="deleteresce(scope.row)">
										<el-button slot="reference" plain size="mini" style="background-color: #ec0f25;">删除</el-button>
									</el-popconfirm>
								</template>
							</el-table-column>
						</el-table>
					</template>
				</div>
				<div class="tabsnum">
					<p>
						显示
						<span>1</span>
						到
						<span>{{ pagesobj.pageSize }}</span>
						,共
						<span>{{ totalall }}</span>
						条记录
					</p>
					<div class="elpagian">
						<el-pagination
							@current-change="changecurr"
							background
							layout="prev, pager, next"
							:page-size="pagesobj.pageSize"
							:total="totalall"
							:current-page="pagesobj.pageIndex"
						></el-pagination>
					</div>
				</div>
			</div>
		</div>

		<el-dialog title="修改单个题目" center :visible.sync="dialogVisibles" :before-close="handleClose">
			<div class="addstras">
				<div class="addstrascenter">
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
						<el-form-item label="专业" prop="CA_GUID">
							<el-select v-model="ruleForm.CA_GUID" placeholder="请选择专业" @change="getpolist()">
								<el-option v-for="item in prolist" :key="item.pro_guid" :label="item.pro_name" :value="item.pro_guid"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="岗位" prop="PR_GUID">
							<el-select v-model="ruleForm.PR_GUID" placeholder="请选择岗位">
								<el-option v-for="item in polist" :key="item.PR_GUID" :label="item.PR_ProfessionalName" :value="item.PR_GUID"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="知识专业" prop="SKY_GUID">
							<el-select v-model="ruleForm.SKY_GUID" clearable placeholder="请选择知识专业">
								<el-option v-for="item in knowledge" :key="item.SKY_GUID" :label="item.SKY_KonwledgeName" :value="item.SKY_GUID"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="等级" prop="IL_GUID">
							<el-select v-model="ruleForm.IL_GUID" clearable placeholder="请选择等级">
								<el-option v-for="item in gradeget" :key="item.IL_GUID" :label="item.IL_LevelTitle" :value="item.IL_GUID"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="状态" prop="SQB_IsDispark">
							<el-select v-model="ruleForm.SQB_IsDispark" placeholder="请选择显示状态">
								<el-option label="公开" :value="1"></el-option>
								<el-option label="私密" :value="0"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="试题选项" prop="typeotion">
							<el-radio-group v-model="ruleForm.SQT_GUID" size="small" @input="changeradios">
								<el-radio v-for="(item, index) in testtypelist" :key="item.SQT_GUID" :label="item.SQT_GUID" :value="item.SQT_GUID" border>
									{{ item.SQT_Name }}
								</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="试题内容" prop="SQB_Question">
							<el-input
								type="textarea"
								:autosize="{ minRows: 4, maxRows: 10 }"
								placeholder="请输入试题内容"
								v-model="ruleForm.SQB_Question"
								maxlength="300"
								show-word-limit
							></el-input>
						</el-form-item>
						<el-form-item label="答案" prop="SQO_OptionName">
							<div style="display: flex;align-items: center;">
								<el-input v-model="ruleForm.SQO_OptionName" style="margin-right: 10px;"></el-input>
								<el-button type="primary" size="small" @click="changequionitm">添加选项</el-button>
							</div>
							<p style="color: #999;font-size: 14px;" v-if="ruleForm.option.length > 0">请在下方题目选择正确答案，默认正确答案为第一个</p>
							<div class="qutionitem" v-for="(ite, idx) in ruleForm.option">
								<p class="qutionits" :style="{ color: ite.SQO_IsAnswer ? '#4eec73' : '' }">{{ ite.SQO_OptionName }}</p>
								<div>
									<el-button title="设置答案" @click="changeanswer(idx)" type="success" size="mini" icon="el-icon-check" circle></el-button>
									<el-button title="移除选项" @click.stop="deleteoption(ite)" type="danger" size="mini" icon="el-icon-delete" circle></el-button>
								</div>
							</div>
						</el-form-item>
						<el-form-item label="答案解析" prop="SQB_AnswerAnalysis">
							<el-input type="textarea" autosize placeholder="请输入答案解析" v-model="ruleForm.SQB_AnswerAnalysis"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="editsForm('ruleForm')">立即修改</el-button>
							<!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
						</el-form-item>
					</el-form>
				</div>
			</div>
		</el-dialog>

		<el-dialog title="添加单个题目" center :visible.sync="dialogVisible" :before-close="handleClose">
			<div class="addstras">
				<div class="addstrascenter">
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="demo-ruleForm">
						<el-form-item label="专业" prop="CA_GUID">
							<el-select v-model="ruleForm.CA_GUID" placeholder="请选择专业" @change="getpolist()">
								<el-option v-for="item in prolist" :key="item.pro_guid" :label="item.pro_name" :value="item.pro_guid"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="岗位" prop="PR_GUID">
							<el-select v-model="ruleForm.PR_GUID" placeholder="请选择岗位">
								<el-option v-for="item in polist" :key="item.PR_GUID" :label="item.PR_ProfessionalName" :value="item.PR_GUID"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="知识专业" prop="SKY_GUID">
							<el-select v-model="ruleForm.SKY_GUID" clearable placeholder="请选择知识专业">
								<el-option v-for="item in knowledge" :key="item.SKY_GUID" :label="item.SKY_KonwledgeName" :value="item.SKY_GUID"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="等级" prop="IL_GUID">
							<el-select v-model="ruleForm.IL_GUID" clearable placeholder="请选择等级">
								<el-option v-for="item in gradeget" :key="item.IL_GUID" :label="item.IL_LevelTitle" :value="item.IL_GUID"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="状态" prop="SQB_IsDispark">
							<el-select v-model="ruleForm.SQB_IsDispark" placeholder="请选择显示状态">
								<el-option label="公开" :value="1"></el-option>
								<el-option label="私密" :value="0"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="试题选项" prop="typeotion">
							<el-radio-group v-model="ruleForm.SQT_GUID" size="small" @input="changeradios">
								<el-radio v-for="(item, index) in testtypelist" :key="item.SQT_GUID" :label="item.SQT_GUID" :value="item.SQT_GUID" border>
									{{ item.SQT_Name }}
								</el-radio>
							</el-radio-group>
						</el-form-item>
						<!-- label-width="150px" -->
						<el-form-item label="试题内容" prop="SQB_Question">
							<el-input
								type="textarea"
								:autosize="{ minRows: 4, maxRows: 10 }"
								placeholder="请输入试题内容"
								v-model="ruleForm.SQB_Question"
								maxlength="300"
								show-word-limit
							></el-input>
						</el-form-item>
						<el-form-item label="答案" prop="SQO_OptionName">
							<div style="display: flex;align-items: center;">
								<el-input v-model="ruleForm.SQO_OptionName" style="margin-right: 10px;"></el-input>
								<el-button type="primary" size="small" @click="changequionitm">添加选项</el-button>
							</div>
							<p style="color: #999;font-size: 14px;" v-if="ruleForm.option.length > 0">请在下方题目选择正确答案，默认正确答案为第一个</p>
							<div class="qutionitem" v-for="(ite, idx) in ruleForm.option">
								<p class="qutionits" :style="{ color: ite.SQO_IsAnswer ? '#4eec73' : '' }">{{ ite.SQO_OptionName }}</p>
								<div>
									<el-button title="设置答案" @click="changeanswer(idx)" type="success" size="mini" icon="el-icon-check" circle></el-button>
									<el-button title="移除选项" @click.stop="deleteoption(ite)" type="danger" size="mini" icon="el-icon-delete" circle></el-button>
								</div>
							</div>
						</el-form-item>
						<el-form-item label="答案解析" prop="SQB_AnswerAnalysis">
							<el-input type="textarea" autosize placeholder="请输入答案解析" v-model="ruleForm.SQB_AnswerAnalysis"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="submitForm('ruleForm')">立即增加</el-button>
							<el-button @click="resetForm('ruleForm')">重置</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</el-dialog>

		<el-dialog title="批量导入" center :visible.sync="setlistsvable" :before-close="handleClose">
			<div class="addstras">
				<div class="addstrascenter">
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="demo-ruleForm">
						<el-form-item label="模板下载" prop="btns">
							<div>
								<el-button type="success" @click="doloads('单选题模板')">单选题模板下载</el-button>
								<el-button type="success" @click="doloads('多选题模板')">多选题模板下载</el-button>
								<el-button type="success" @click="doloads('判断题模板')">判断题模板下载</el-button>
							</div>
						</el-form-item>
						<el-form-item label="专业" prop="CA_GUID">
							<el-select v-model="ruleForm.CA_GUID" placeholder="请选择专业" @change="getpolist()">
								<el-option v-for="item in prolist" :key="item.pro_guid" :label="item.pro_name" :value="item.pro_guid"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="岗位" prop="PR_GUID">
							<el-select v-model="ruleForm.PR_GUID" placeholder="请选择岗位">
								<el-option v-for="item in polist" :key="item.PR_GUID" :label="item.PR_ProfessionalName" :value="item.PR_GUID"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="知识专业" prop="SKY_GUID">
							<el-select v-model="ruleForm.SKY_GUID" clearable placeholder="请选择知识专业">
								<el-option v-for="item in knowledge" :key="item.SKY_GUID" :label="item.SKY_KonwledgeName" :value="item.SKY_GUID"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="等级" prop="IL_GUID">
							<el-select v-model="ruleForm.IL_GUID" clearable placeholder="请选择等级">
								<el-option v-for="item in gradeget" :key="item.IL_GUID" :label="item.IL_LevelTitle" :value="item.IL_GUID"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="状态" prop="SQB_IsDispark">
							<el-select v-model="ruleForm.SQB_IsDispark" placeholder="请选择显示状态">
								<el-option label="公开" :value="1"></el-option>
								<el-option label="私密" :value="0"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="试题选项" prop="typeotion">
							<el-radio-group v-model="ruleForm.SQT_GUID" size="small" @input="changeradios">
								<el-radio v-for="(item, index) in testtypelist" :key="item.SQT_GUID" :label="item.SQT_GUID" :value="item.SQT_GUID" border>
									{{ item.SQT_Name }}
								</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="文件上传" prop="typeotion" v-if="ruleForm.SQT_GUID != ''">
							<el-upload class="upload-demo" action="#" accept=".xls" :limit="1" :auto-upload="false" :on-change="handleChange" :file-list="fileList">
								<el-button size="small" type="primary">点击上传</el-button>
								<div slot="tip" class="el-upload__tip">只能上传xsl，文件，且不超过10MB</div>
							</el-upload>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="submitFormdr('ruleForm')">立即增加</el-button>
							<el-button @click="resetForm('ruleForm')">重置</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</el-dialog>

		<el-dialog title="题库导出" :visible.sync="chiocetestdialogVisible" :before-close="handleClose">
			<div class="addstras">
				<div class="addstrascenter">
					<el-form :model="ruleForm" ref="ruleForm" label-width="130px" class="demo-ruleForm">
						<el-form-item label="专业" prop="CA_GUID">
							<el-select v-model="ruleForm.CA_GUID" placeholder="请选择专业" @change="getpolist()">
								<el-option v-for="item in prolist" :key="item.pro_guid" :label="item.pro_name" :value="item.pro_guid"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="岗位" prop="PR_GUID">
							<el-select v-model="ruleForm.PR_GUID" placeholder="请选择岗位">
								<el-option v-for="item in polist" :key="item.PR_GUID" :label="item.PR_ProfessionalName" :value="item.PR_GUID"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="知识专业" prop="SKY_GUID">
							<el-select v-model="ruleForm.SKY_GUID" clearable placeholder="请选择知识专业">
								<el-option v-for="item in knowledge" :key="item.SKY_GUID" :label="item.SKY_KonwledgeName" :value="item.SKY_GUID"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="等级" prop="IL_GUID">
							<el-select v-model="ruleForm.IL_GUID" clearable placeholder="请选择等级">
								<el-option v-for="item in gradeget" :key="item.IL_GUID" :label="item.IL_LevelTitle" :value="item.IL_GUID"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="状态" prop="SQB_IsDispark">
							<el-select v-model="ruleForm.SQB_IsDispark" placeholder="请选择显示状态">
								<el-option label="公开" :value="1"></el-option>
								<el-option label="私密" :value="0"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="试题选项" prop="typeotion">
							<el-radio-group v-model="ruleForm.SQT_GUID" size="small" @input="changeradios">
								<el-radio v-for="(item, index) in testtypelist" :key="item.SQT_GUID" :label="item.SQT_GUID" :value="item.SQT_GUID" border>
									{{ item.SQT_Name }}
								</el-radio>
							</el-radio-group>
						</el-form-item>

						<el-form-item>
							<el-button type="primary" @click="submitqutionst('ruleForm')">立即导出</el-button>
							<!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
						</el-form-item>
					</el-form>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';
import {
	changeKonwledgeType,
	getGetQuetype,
	GetQuestionList,
	GetTrainingStrategyList,
	getGetProfList,
	getPositionList,
	changeGradeGet,
	getGetResourceTypes,
	QuestionAdd,
	DeleteQuestion,
	QuestionDetails,
	UpdateQuestion,
	ImportQuestion,
	ExportToExcels
} from '@/request/api/homesview/yunhomes/yunhom.js';

import { GetzyProfList } from '@/request/api/mange/mange.js';

import AppOptions from '@/config/AppOptions.vue';

export default {
	data() {
		return {
			chiocetestdialogVisible: false,
			dialogVisibles: false,
			dialogVisible: false,
			// 标题
			paths: [
				{
					path: '/homesview/testists/questionbank',
					name: '题库管理'
				}
			],
			totalall: 0,
			fileList: [],
			// 专业筛选项列表
			options: [],
			value: '',
			input: '',
			pagesobj: {
				pageSize: 10,
				pageIndex: 1,
				sm_title: '',
				smt_guid: '',
				PR_GUID: '',
				PCR_RuleTitle: '',
				IL_GUID: '',
				pro_guid: '',
				PCT_IsState: '',
				SKY_GUID: '',
				SQB_IsDispark: '',
				SQT_GUID: '',
				StartTime: '',
				EndTime: '',
				SKY_GUID: ''
			},
			tabsnun: 1,
			tableData: [],
			// 获取专业、岗位、资源类型列表
			rtlist: [],
			prolist: [],
			polist: [],
			rtlist: [],
			gradeget: [],
			quesvalue: '',
			// 知识类别  试题类型
			knowledge: [],
			testtypelist: [],
			// 表单
			ruleForm: {
				CA_GUID: '',
				PR_GUID: '',
				SKY_GUID: '',
				IL_GUID: '',
				SQB_IsDispark: 1,
				SQB_Question: '',
				SQO_OptionName: '',
				option: [],
				typeotion: 1,
				SQB_AnswerAnalysis: '',
				SQT_GUID: '',
				btns: ''
			},
			ruleFormcopy: {
				CA_GUID: '',
				PR_GUID: '',
				SKY_GUID: '',
				IL_GUID: '',
				SQB_IsDispark: 1,
				SQB_Question: '',
				SQO_OptionName: '',
				option: [],
				typeotion: 1,
				SQB_AnswerAnalysis: '',
				SQT_GUID: '',
				btns: ''
			},
			rules: {
				SKY_GUID: [{ required: true, message: '请输入知识专业', trigger: 'blur' }],
				PR_GUID: [{ required: true, message: '请选择岗位', trigger: 'change' }],
				IL_GUID: [{ required: true, message: '请选择等级', trigger: 'change' }],
				CA_GUID: [{ required: true, message: '请选择专业', trigger: 'change' }],
				SQB_Question: [{ required: true, message: '请输入试题内容', trigger: 'blur' }],
				SQB_AnswerAnalysis: [{ required: true, message: '请输入答案解析', trigger: 'blur' }],
				SQT_GUID: [{ required: true, message: '请输入试题类型', trigger: 'change' }]
			},
			isrelenum: 6,
			istypeotionces: '',
			setlistsvable: false,
			qustchiocelist: []
		};
	},
	mounted() {
		// this.ruleFormcopy = JSON.parse(JSON.stringify(this.ruleForm));

		this.get();
	},
	updated() {
		// console.log(this.dialogVisible,"关闭")
	},
	created() {
		AppOptions.appEmpty = false;
	},
	computed: {},
	methods: {
		// 立即导出
		submitqutionst(formName) {
			this.$refs[formName].validate(valid => {
				let objs = {
					SKY_GUID: this.ruleForm.SKY_GUID,
					SQB_IsDispark: this.ruleForm.SQB_IsDispark,
					SQT_GUID: this.ruleForm.SQT_GUID,
					PR_GUID: this.ruleForm.PR_GUID,
					pro_guid: this.ruleForm.pro_guid,
					IL_GUID: this.ruleForm.IL_GUID
				};
				// console.log(objs);
				ExportToExcels(objs).then(res => {
					// console.log(res,"获取")

					const link = document.createElement('a');
					const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
					link.style.display = 'none';
					link.href = URL.createObjectURL(blob);
					link.setAttribute('download', `题目.xlsx`);
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);

					this.chiocetestdialogVisible = false;
				});
			});
		},

		gosettimulist() {
			this.ruleForm.CA_GUID = '';
			this.ruleForm.PR_GUID = '';
			this.ruleForm.SKY_GUID = '';
			this.ruleForm.IL_GUID = '';
			this.ruleForm.SQB_IsDispark = '';
			this.ruleForm.SQT_GUID = '';

			this.chiocetestdialogVisible = true;
			// this.resetForm('ruleForm')
			// 题目列表
			// console.log(this.qustchiocelist,"获取题目列表")
			// if(this.qustchiocelist.length==0){
			// 	this.$message("请选择题目")
			// 	return
			// }
		},
		// 单选
		selectionchange(list, row) {
			if (this.qustchiocelist.find(item => item.SQB_GUID == row.SQB_GUID)) {
				//下面这个filter方法就是删除的方法
				this.qustchiocelist = this.qustchiocelist.filter(item => item.SQB_GUID != row.SQB_GUID);
			} else {
				this.qustchiocelist.push(row);
			}
		},
		// 全选
		//该方法是当页全选的方法
		handleSelectAll(rows) {
			if (rows.length) {
				rows.forEach(row => {
					if (!this.qustchiocelist.find(item => item.SQB_GUID == row.SQB_GUID)) {
						this.qustchiocelist.push(row);
					}
				});
			} else {
				this.tableData.forEach(row => {
					this.qustchiocelist = this.qustchiocelist.filter(item => item.SQB_GUID != row.SQB_GUID);
				});
			}
		},
		// 提交修改
		// 表单
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					if (this.ruleForm.SQT_GUID == '') {
						this.$message('请选择题目');
						return;
					}
					if (!this.ruleForm.option.some(itm => itm.SQO_IsAnswer)) {
						this.$message('请选择题目答案');
						return;
					}

					QuestionAdd(this.ruleForm).then(res => {
						if (res.data.code > 0) {
							this.$message.success(res.data.msg);
							this.dialogVisible = false;
							this.getresours();
						}
					});
				} else {
					return false;
				}
			});
		},
		editsForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					if (this.ruleForm.SQT_GUID == '') {
						this.$message('请选择题目');
						return;
					}
					if (!this.ruleForm.option.some(itm => itm.SQO_IsAnswer)) {
						this.$message('请选择题目答案');
						return;
					}

					UpdateQuestion(this.ruleForm).then(res => {
						if (res.data.code > 0) {
							this.$message.success(res.data.msg);
							this.dialogVisibles = false;
							this.getresours();
						}
					});
				} else {
					return false;
				}
			});
		},
		submitFormdr(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					if (this.ruleForm.SQT_GUID == '') {
						this.$message('请选择题目');
						return;
					}
					if (this.fileList.length == 0) {
						this.$message('请上传对应的题目模板');
						return;
					}

					// console.log(this.fileList,"图片列表")
					var formData = new FormData();
					formData.append('pro_guid', this.ruleForm.CA_GUID);
					formData.append('PR_GUID', this.ruleForm.PR_GUID);
					formData.append('SKY_GUID', this.ruleForm.SKY_GUID);
					formData.append('IL_GUID', this.ruleForm.IL_GUID);
					formData.append('SQB_IsDispark', this.ruleForm.SQB_IsDispark);
					formData.append('SQT_GUID', this.ruleForm.SQT_GUID);
					formData.append('filedata', this.fileList[0].raw);

					ImportQuestion(formData).then(res => {
						if (res.data.code > 0) {
							this.$message.success(res.data.msg);
							this.setlistsvable = false;
							// this.ruleForm = this.ruleFormcopy;

							this.getresours();
						}
					});
				} else {
					return false;
				}
			});
		},
		beforechangefilezy() {
			// 上传之前
		},
		// 上次表格
		handleChange(file, fileList) {
			this.fileList = fileList;
		},
		addtimulist() {
			// console.log('批量导入');
			this.setlistsvable = true;
			this.fileList = [];
		},
		doloads(fliename) {
			window.location.href = 'https://www.hngtsd.net:65535/Template/' + fliename + '.xls';
		},
		addtimu() {
			// console.log(this.ruleFormcopy);
			let ruleFormcopy = {
				CA_GUID: '',
				PR_GUID: '',
				SKY_GUID: '',
				IL_GUID: '',
				SQB_IsDispark: 1,
				SQB_Question: '',
				SQO_OptionName: '',
				option: [],
				typeotion: 1,
				SQB_AnswerAnalysis: '',
				SQT_GUID: '',
				btns: ''
			};

			this.ruleForm = ruleFormcopy;
			this.dialogVisible = true;
		},
		resetForm(formName) {
			this.ruleForm = {};
			// 重置
			this.$refs[formName].resetFields();
		},
		changequionitm() {
			// ruleForm.SQO_OptionName
			if (this.ruleForm.SQO_OptionName == '') {
				this.$message('请输入答案');
				return;
			}
			if (this.ruleForm.option.length >= this.isrelenum) {
				this.$message('判断题只有两个选项');
				return;
			}
			if (this.ruleForm.SQB_Question == '') {
				this.$message('请输入题目');
				return;
			}
			let option = {
				SQO_OptionName: this.ruleForm.SQO_OptionName,
				SQO_IsAnswer: false
			};

			this.ruleForm.option.push(option);
			// console.log(this.ruleForm.option.some(itm => itm.SQO_IsAnswer))
			if (!this.ruleForm.option.some(itm => itm.SQO_IsAnswer)) {
				this.ruleForm.option[0].SQO_IsAnswer = true;
			}

			this.ruleForm.SQO_OptionName = '';
		},
		deleteoption(itm) {
			let ruleobj = JSON.parse(JSON.stringify(this.ruleForm));
			ruleobj.option.splice(ruleobj.option.indexOf(itm), 1);

			this.ruleForm = ruleobj;
			// console.log(this.ruleForm.option)
		},
		changeanswer(idx) {
			let ruleFormlist = JSON.parse(JSON.stringify(this.ruleForm));
			if (this.istypeotionces != '4EBE5A8F10644FBF8FE61151567F90A3') {
				ruleFormlist.option.forEach(itm => (itm.SQO_IsAnswer = false));
				// console.log(ruleFormlist.option,'获取11111')
				ruleFormlist.option[idx].SQO_IsAnswer = true;

				this.ruleForm = ruleFormlist;
			} else {
				ruleFormlist.option[idx].SQO_IsAnswer = !ruleFormlist.option[idx].SQO_IsAnswer;

				this.ruleForm = ruleFormlist;
			}

			// console.log(this.ruleForm.option[idx],idx)
		},
		changeradios(e) {
			// console.log(e,this.ruleForm.typeotion)
			// if(e==3){}
			// console.log(e,"id")
			if (this.ruleForm.option.length > 0) {
				this.$confirm('当前题目未添加, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						this.istypeotionces = e;
						this.ruleForm.option = [];
						if (e == 'BCDC7963A8A34C5788501CFCDE87487D') {
							this.isrelenum = 2;
						} else {
							this.isrelenum = 6;
						}
						this.ruleForm.SQO_OptionName = '';
						this.ruleForm.SQB_Question = '';
					})
					.catch(() => {
						this.ruleForm.typeotion = this.istypeotionces;
					});
			} else {
				if (e == 'BCDC7963A8A34C5788501CFCDE87487D') {
					this.isrelenum = 2;
				} else {
					this.isrelenum = 6;
				}
				this.ruleForm.SQO_OptionName = '';
				this.ruleForm.SQB_Question = '';
				this.istypeotionces = e;
			}
		},
		handleClose(done) {
			this.$confirm('确认关闭？')
				.then(_ => {
					done();
				})
				.catch(_ => {});
		},
		// 知识类别
		getknowlist() {
			let knowobj = {
				SKY_KonwledgeName: ''
			};
			changeKonwledgeType(knowobj).then(res => {
				this.knowledge = res.data.data;
			});
		},
		// 试题类型
		getquestype() {
			getGetQuetype().then(res => {
				// console.log(res,"获取试题类型")
				this.testtypelist = res.data.data;
			});
		},

		getprolist() {
			this.prolist = [];

			if (localStorage.getItem('uiguid') == 'f2b9986b57074d2cb2dadd07f6ee62bb') {
				getGetProfList().then(res => {
					// console.log(res.data.data)
					if (res.data.code > 0) {
						this.prolist = res.data.data;
						if (this.pagesobj.pro_guid !== '') {
							this.getpolist();
						}
					}
				});
			} else {
				GetzyProfList(localStorage.getItem('siguid')).then(res => {
					// console.log(res.data.data)
					if (res.data.code > 0) {
						this.prolist = res.data.data;
						if (this.pagesobj.pro_guid !== '') {
							this.getpolist();
						}
					}
				});
			}
		},
		getpolist() {
			let proguid = '';
			if (this.ruleForm.CA_GUID != '') {
				proguid = this.ruleForm.CA_GUID;
			} else {
				proguid = this.pagesobj.pro_guid;
			}
			this.ruleForm.PR_GUID = '';
			this.pagesobj.PR_GUID = '';
			this.polist = [];
			if (proguid == '') {
				return;
			}
			// console.log("切换节点时促发")
			getPositionList(proguid).then(res => {
				if (res.data.code > 0) {
					this.polist = res.data.data;
				}
			});
		},
		editszy(itm) {
			// 点击编辑 获取详情
			// console.log("点击编辑")
			let source = {
				SQB_GUID: itm.SQB_GUID
			};
			QuestionDetails(source).then(res => {
				// console.log(res);
				this.dialogVisibles = true;
				this.ruleForm = JSON.parse(JSON.stringify(res.data.data));
				this.ruleForm.option = JSON.parse(JSON.stringify(res.data.data)).Questionoptions;
				if (this.ruleForm.SQT_GUID == 'BCDC7963A8A34C5788501CFCDE87487D') {
					this.isrelenum = 2;
				} else {
					this.isrelenum = 6;
				}
				this.istypeotionces = this.ruleForm.SQT_GUID;

				// console.log(res.data.data);

				getPositionList(this.ruleForm.CA_GUID).then(res => {
					if (res.data.code > 0) {
						this.polist = res.data.data;
					}
				});

				if (this.ruleForm.SQB_IsDispark) {
					this.ruleForm.SQB_IsDispark = 1;
				} else {
					this.ruleForm.SQB_IsDispark = 0;
				}
			});
		},
		deleteresce(re) {
			let review = {
				SQB_GUID: re.SQB_GUID
			};
			DeleteQuestion(review).then(res => {
				if (res.data.code > 0) {
					this.$message.success(res.data.msg);
					this.get();
				}
			});
		},
		changesqx(e) {
			if (e == 0) {
				return '全网公开（所有登录用户）';
			} else if (e == 1) {
				return '只对本院校公开';
			} else if (e == 2) {
				return '全网公开（游客、非注册用户）';
			} else {
				return '私有';
			}
		},
		indexMethod(index) {
			return index + 1;
		},
		changecurr(val) {
			this.pagesobj.pageIndex = val;
			this.getresours();
		},
		get() {
			this.getresours();
			this.getprolist();
			this.getgrads();
			this.getknowlist();
			this.getquestype();
			// console.log("请求")
		},
		// 改变
		changetablesize() {
			this.getresours();
		},
		getgrads() {
			changeGradeGet().then(res => {
				// console.log("获取等级",res)
				this.gradeget = res.data.data;
			});
		},

		getResourceType() {
			getGetResourceTypes().then(res => {
				if (res.data.code > 0) {
					this.rtlist = res.data.data;
				}
			});
		},
		getresours() {
			// console.log(this.quesvalue)
			if (this.quesvalue) {
				this.pagesobj.StartTime = this.quesvalue[0];
				this.pagesobj.EndTime = this.quesvalue[1];
			} else {
				this.pagesobj.StartTime = '';
				this.pagesobj.EndTime = '';
			}

			GetQuestionList(this.pagesobj).then(res => {
				if (res.data.code > 0) {
					// console.log(res)
					this.tableData = res.data.data.list;
					this.totalall = res.data.data.totalCount;

					this.$nextTick(() => {
						this.tableData.forEach((item, index) => {
							if (this.qustchiocelist.findIndex(v => v.SQB_GUID == item.SQB_GUID) >= 0) {
								console.log('获取单选', item);
								this.$refs.childtable.toggleRowSelection(item, true);
							}
						});
					});
				}
			});
		}
	},
	components: {
		titles
	}
};
</script>
